// extracted by mini-css-extract-plugin
export var editInput = "_gg-0";
export var editInputCompact = "_gg-2";
export var editInputLarge = "_gg-1";
export var editInputSmall = "_gg-3";